import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy()

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  token: string | null = null;
  password: string = '';
  confirmPassword: string = '';
  validationError: string | null = null;

  constructor(private route: ActivatedRoute, private authService: AuthService) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');
  }

  onSubmit(): void {
    if (this.password === '' && this.confirmPassword === '' && (this.password !== this.confirmPassword)) {
      this.validationError = 'Passwords do not match.';
      return;
    }

    this.validationError = null;
    // Call the backend API to reset the password
    const queryParams = {
      token:this.token
    }
    this.authService.resetPassword({password:this.password},queryParams).pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if(data){
        console.log('Password reset successfully:', this.password);
        
      }
    })
  }
}
